let selectedCurrency = localStorage.getItem("app_currency") || "LRD";
let exchangeRate = localStorage.getItem("exchangeRate") || 1;

export const setGlobalCurrency = (currency) => {
  selectedCurrency = currency;
  localStorage.setItem("app_currency", currency);
};

export const getGlobalCurrency = () => selectedCurrency;
export const getExchangeRate = () => exchangeRate;

export const setExchangeRate = (rate) => {
  localStorage.setItem("exchangeRate", rate);
  exchangeRate = Number(rate) || 1;
};

export const convertPrice = (price, productCurrency) => {
  console.log(selectedCurrency)
  const _exchangeRate =Number(exchangeRate)
  // console.log(productCurrency)
  // const _productCurrency =getGlobalCurrency()
  // console.log(_productCurrency)
  // clg
  // console.log(ff)
  const numericPrice = Number(price || 0);
  console.log(_exchangeRate)

  if (productCurrency === selectedCurrency) {
    return numericPrice;
  }

  if (productCurrency === "USD" && selectedCurrency === "LRD") {
    return numericPrice * _exchangeRate;
  }

  if (productCurrency === "LRD" && selectedCurrency === "USD") {
    return numericPrice / _exchangeRate;
  }

  return numericPrice;
};

export const priceConversion = ( price , convertToCurrency , originalCurrency)=>{
  console.log(exchangeRate)
   const numericPrice = Number(price || 0);

  if (originalCurrency === convertToCurrency) {
    return numericPrice;
  }

  if (originalCurrency === "USD" && convertToCurrency === "LRD") {
    return numericPrice * exchangeRate;
  }

  if (originalCurrency === "LRD" && convertToCurrency === "USD") {
    return numericPrice / exchangeRate;
  }

  return numericPrice;
  
}